import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { FaStar } from 'react-icons/fa';

const Reviews = () => {
  const { t } = useLanguage();

  const reviews = [
    {
      name: 'Ahmad bin Hassan',
      rating: 5,
      date: 'December 2024',
      comment: 'Professional service and honest advice. They diagnosed my BMW issue accurately and fixed it at a fair price. Highly recommended for European cars!',
      vehicle: 'BMW 320i'
    },
    {
      name: 'Tan Wei Ming',
      rating: 5,
      date: 'November 2024',
      comment: 'Excellent hybrid battery service. My Toyota Prius battery was repaired quickly and the car runs perfectly now. Great team!',
      vehicle: 'Toyota Prius'
    },
    {
      name: 'Lee Siew Lan',
      rating: 4,
      date: 'November 2024',
      comment: 'Good diagnostic service. They found the electrical issue in my Audi that other workshops couldn\'t detect. Will return for future service.',
      vehicle: 'Audi A4'
    },
    {
      name: 'Raj Kumar',
      rating: 5,
      date: 'October 2024',
      comment: 'Transparent pricing and professional technicians. They explained everything clearly before starting the work. Very satisfied with Mercedes service.',
      vehicle: 'Mercedes-Benz C200'
    },
    {
      name: 'Wong Li Ying',
      rating: 4,
      date: 'October 2024',
      comment: 'Fast turnaround time for major service. Reasonable pricing compared to other workshops in Johor. Good experience overall.',
      vehicle: 'Volkswagen Golf'
    },
    {
      name: 'Hassan Ali',
      rating: 5,
      date: 'September 2024',
      comment: 'Best workshop for hybrid vehicles in Muar! They repaired my Lexus hybrid system professionally. Highly skilled team.',
      vehicle: 'Lexus ES300h'
    }
  ];

  return (
    <div className="min-h-screen" data-testid="reviews-page">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center bg-royal-blue">
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full text-center">
          <div className="flex items-center justify-center mb-4">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} className="text-yellow-400 mx-1" size={32} />
            ))}
          </div>
          <h1 className="font-cabinet font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white mb-4">
            {t('reviews.title')}
          </h1>
          <p className="text-lg text-gray-200">{t('reviews.rating')}: 3.9 / 5.0</p>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((review, index) => (
              <div 
                key={index}
                data-testid={`review-card-${index}`}
                className="bg-light-grey p-8 border border-gray-200 hover:shadow-md transition-shadow"
              >
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <FaStar 
                      key={i} 
                      className={i < review.rating ? 'text-yellow-400' : 'text-gray-300'} 
                      size={20} 
                    />
                  ))}
                </div>
                <p className="text-gray-700 text-base leading-relaxed mb-4 italic">
                  "{review.comment}"
                </p>
                <div className="border-t border-gray-300 pt-4">
                  <p className="font-cabinet font-bold text-dark-navy">{review.name}</p>
                  <p className="text-sm text-gray-600">{review.vehicle}</p>
                  <p className="text-xs text-gray-500 mt-1">{review.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-light-grey">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-cabinet font-bold text-2xl sm:text-3xl text-dark-navy mb-4">
            Experience Our Service
          </h2>
          <p className="text-base mb-8 text-gray-600">
            Join our satisfied customers today
          </p>
          <a 
            href="/contact"
            data-testid="reviews-cta-contact"
            className="inline-block px-8 py-3 bg-royal-blue text-white font-cabinet font-bold hover:bg-[#002277] transition-colors"
          >
            {t('hero.cta1')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default Reviews;